import NavigationHistoryContext from '@/contexts/navigation-history-context';
import { useContext } from 'react';

export const useNavigationHistory = () => useContext(NavigationHistoryContext);
